import * as tslib_1 from "tslib";
import { EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { util } from '../../../classes/util';
import { ESRI } from '../../../esri-loader-util';
import { BooleanConverter, InputConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var Graphic;
var PopupConstructor;
var LayerTooltipComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LayerTooltipComponent, _super);
    function LayerTooltipComponent(_vcr, layerService) {
        var _this = _super.call(this, _vcr) || this;
        _this.layerService = layerService;
        _this.highlightColor = 'rgba(125, 247, 229, 0.75)';
        _this.highlightEnabled = false;
        _this.opening = new EventEmitter();
        _this.mouseInside = false;
        _this.closeTooltip = function () {
            if (_this.popupRef) {
                _this.popupRef.close();
                _this.highlightLayer.removeAll();
            }
        };
        return _this;
    }
    Object.defineProperty(LayerTooltipComponent.prototype, "tooltipEnabled", {
        get: function () {
            return this._tooltipEnabled;
        },
        set: function (value) {
            this._tooltipEnabled = BooleanConverter(value);
            if (this.tooltipEnabled) {
                this.enableTooltip();
            }
            else {
                this.disableTooltip();
            }
        },
        enumerable: true,
        configurable: true
    });
    LayerTooltipComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, error_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 4, 5, 6]);
                        _b = this;
                        return [4 /*yield*/, this.getClosestAncestor('mc-map')];
                    case 1:
                        _b.mapRef = _c.sent();
                        return [4 /*yield*/, this.mapRef.ready];
                    case 2:
                        _c.sent();
                        this.mapView = this.mapRef.mapView;
                        this.tooltipEnabled = this.tooltipEnabled === undefined ? (this.mapView.mapcoreViewProps && this.mapView.mapcoreViewProps.tooltip ? true : false) : this.tooltipEnabled;
                        this.mapView.popup.autoOpenEnabled = false;
                        return [4 /*yield*/, Promise.all([ESRI.Graphic, ESRI.Popup])];
                    case 3:
                        _a = tslib_1.__read.apply(void 0, [_c.sent(), 2]), Graphic = _a[0], PopupConstructor = _a[1];
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _c.sent();
                        this.readyProblem(error_1);
                        return [3 /*break*/, 6];
                    case 5:
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    LayerTooltipComponent.prototype.enableTooltip = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, containerWatch_1, waitTime_1, pointerDebounce_1;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.ready];
                    case 1:
                        _b.sent();
                        if (!!this.popupRef) return [3 /*break*/, 4];
                        this.mapView.popup = new PopupConstructor({
                            autoOpenEnabled: false,
                            defaultPopupTemplateEnabled: true
                        });
                        this.popupRef = this.mapView.popup;
                        this.popupVisibleWatcher = this.popupRef.watch('visible', function () {
                            if (!_this.popupRef.visible) {
                                if (_this.highlightEnabled) {
                                    _this.highlightLayer.removeAll();
                                }
                                _this.mouseInside = false;
                            }
                        });
                        if (!this.highlightEnabled) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({
                                title: 'Tooltip Highlight',
                                hideInLegend: true
                            })];
                    case 2:
                        _a.highlightLayer = _b.sent();
                        this.popupSelectedFeatureWatcher = this.popupRef.watch('selectedFeature', function (g) {
                            _this.highlightGraphic(g);
                        });
                        _b.label = 3;
                    case 3:
                        containerWatch_1 = this.popupRef.watch('container', function () {
                            var container = _this.popupRef.container;
                            container.addEventListener('mouseenter', _this.mouseEnterHandler.bind(_this));
                            container.addEventListener('mouseleave', _this.mouseLeaveHandler.bind(_this));
                            containerWatch_1.remove();
                        });
                        waitTime_1 = 500;
                        pointerDebounce_1 = util.debounce(function (e) {
                            _this.clearWorkTimeout();
                            if (!_this.mouseInside) {
                                _this.timeoutId = window.setTimeout(_this.work.bind(_this, e), waitTime_1);
                            }
                        }, waitTime_1);
                        this.mapPointerMoveHandler = this.mapView.on('pointer-move', function (e) {
                            if (_this.popupRef && _this._tooltipEnabled) {
                                pointerDebounce_1.call(_this, e);
                            }
                        });
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LayerTooltipComponent.prototype.clearWorkTimeout = function () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    };
    LayerTooltipComponent.prototype.work = function (args) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mapPoint, screenPoint, hasGraphic, layerHasId;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mapPoint = this.mapView.toMap(args);
                        screenPoint = this.mapView.toScreen(mapPoint);
                        return [4 /*yield*/, this.hasGraphicFromGraphicsLayer(screenPoint)];
                    case 1:
                        hasGraphic = _a.sent();
                        layerHasId = function (layerId) { return function (layer) { return layer.mapcoreProps && layer.mapcoreProps.idFromSavedLayer === layerId; }; };
                        if (this.popupRef) {
                            this.popupRef.fetchFeatures(screenPoint).then(function (response) {
                                if (!_this.popupRef) {
                                    return;
                                }
                                response.allGraphicsPromise.then(function (graphics) {
                                    var event = { cancel: false };
                                    _this.opening.emit(event);
                                    if (event.cancel) {
                                        return;
                                    }
                                    var anyLayerHoverEnabled = graphics.some(function (g) {
                                        return g.sourceLayer
                                            && g.sourceLayer.mapcoreProps
                                            && g.sourceLayer.mapcoreProps.hoverEnabled !== false;
                                    });
                                    if ((graphics.length === 0 && !hasGraphic)
                                        || !anyLayerHoverEnabled) {
                                        return;
                                    }
                                    // Sort graphics to match the order of layers on the map
                                    graphics.sort(function (first, second) {
                                        var firstId = first.sourceLayer.mapcoreProps.idFromSavedLayer;
                                        var secondId = second.sourceLayer.mapcoreProps.idFromSavedLayer;
                                        var mapLayers = _this.mapView.map.allLayers.toArray();
                                        var firstIndex = mapLayers.findIndex(layerHasId(firstId));
                                        var secondIndex = mapLayers.findIndex(layerHasId(secondId));
                                        return secondIndex - firstIndex;
                                    });
                                    if (_this.highlightEnabled) {
                                        _this.highlightGraphic(graphics[0]);
                                    }
                                    _this.popupRef.open({
                                        location: mapPoint,
                                        features: graphics
                                    });
                                });
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerTooltipComponent.prototype.highlightGraphic = function (feature) {
        var highlightSymbol;
        if (feature.symbol) {
            highlightSymbol = tslib_1.__assign({}, feature.symbol);
        }
        else {
            switch (feature.geometry.type) {
                case 'point':
                    highlightSymbol = { type: 'simple-marker', outline: { color: this.highlightColor } };
                    break;
                case 'polyline':
                    highlightSymbol = { type: 'simple-line', width: 3 };
                    break;
                case 'polygon':
                    highlightSymbol = { type: 'simple-fill' };
                    break;
                default:
                    highlightSymbol = { type: 'simple-marker' };
                    break;
            }
        }
        highlightSymbol.color = this.highlightColor;
        this.highlightLayer.removeAll();
        this.highlightLayer.add(new Graphic({
            geometry: feature.geometry,
            symbol: highlightSymbol
        }));
    };
    LayerTooltipComponent.prototype.mouseEnterHandler = function () {
        this.clearWorkTimeout();
        this.mouseInside = true;
    };
    LayerTooltipComponent.prototype.mouseLeaveHandler = function () {
        this.mouseInside = false;
    };
    LayerTooltipComponent.prototype.hasGraphicFromGraphicsLayer = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mapView.hitTest(event)];
                    case 1:
                        response = _a.sent();
                        if (response.results.length) {
                            response.results.forEach(function (result) {
                                var graphic = result.graphic;
                                if (graphic.layer.type === 'graphics' && graphic.geometry.type === 'point') {
                                    return true;
                                }
                            });
                        }
                        else {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerTooltipComponent.prototype.disableTooltip = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var container;
            return tslib_1.__generator(this, function (_a) {
                if (this.popupRef) {
                    if (this.popupRef.visible) {
                        if (this.popupSelectedFeatureWatcher) {
                            this.popupSelectedFeatureWatcher.remove();
                        }
                        this.popupVisibleWatcher.remove();
                        this.popupRef.close();
                    }
                    if (this.highlightLayer) {
                        this.mapRef.map.layers.remove(this.highlightLayer);
                        this.highlightLayer = null;
                    }
                    container = this.popupRef.container;
                    container.removeEventListener('mouseenter', this.mouseEnterHandler.bind(this));
                    container.removeEventListener('mouseleave', this.mouseLeaveHandler.bind(this));
                    this.mouseInside = false;
                    this.popupRef = undefined;
                }
                if (this.mapView && this.mapView.mapcoreViewProps) {
                    this.mapView.mapcoreViewProps.tooltip = false;
                }
                if (this.mapPointerMoveHandler) {
                    this.mapPointerMoveHandler.remove();
                    this.mapPointerMoveHandler = undefined;
                }
                return [2 /*return*/];
            });
        });
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object)
    ], LayerTooltipComponent.prototype, "highlightEnabled", void 0);
    return LayerTooltipComponent;
}(BaseComponent));
export { LayerTooltipComponent };
